export enum FeatureFlag {
  ABTestPlayingInsightsProfitLoss = 'abtest_playing_insights_profitloss',
  AMLLoginMsg = 'aml-login-msg',
  AMLLoginMsgVerified = 'aml-login-msg-verified',
  AccountChangeMobile = 'account_change_mobile',
  AccountCreatedContinue = 'AccountCreatedContinue',
  AccountMenuAddressSearch = 'acc-menu-address-search',
  Add2HomeScreen = 'a2hs',
  AddressUpdateDisabled = 'address-update-disabled',
  AllowSoftRedirectCancel = 'allow-soft-redirect-cancel',
  BankID = 'se-bankid-signup',
  BlackListCheck = 'blacklist-check',
  CasinoFavorites = 'CasinoFavorites',
  CasinoFreeSpinsToken = 'CasinoFreeSpinsToken',
  CasinoGameFeatureBonusFeatures = 'CasinoGameFeatureBonusFeatures',
  CasinoGameFeatureMaxBet = 'CasinoGameFeatureMaxBet',
  CasinoGameFeatureMinBet = 'CasinoGameFeatureMinBet',
  CasinoGameFeatureMultiplier = 'CasinoGameFeatureMultiplier',
  CasinoGameFeaturePaylines = 'CasinoGameFeaturePaylines',
  CasinoGameFeatureRTP = 'CasinoGameFeatureRTP',
  CasinoGameFeatureWilds = 'CasinoGameFeatureWilds',
  CasinoGameInfo = 'CasinoGameInfo',
  CasinoGameInfoDescription = 'CasinoGameInfoDescription',
  CasinoGameInfoDesktop = 'CasinoGameInfoDesktop',
  CasinoGameInfoMobile = 'CasinoGameInfoMobile',
  CasinoInstantBonusesToken = 'CasinoInstantBonusesToken',
  CasinoLimits = 'eCasinoLimits',
  CasinoLiveRacesTCReqd = 'CasinoLiveRacesTCReqd',
  CasinoLiveRoulette = 'CasinoLiveRouletteResultsFeed',
  CasinoNonAuth = 'eCasinoNonAuth',
  CasinoRewardsStoreToken = 'CasinoRewardsStoreToken',
  CasinoSlotRacesTCReqd = 'CasinoSlotRacesTCReqd',
  CasinoSpinOfDay = 'CasinoSpinOfTheDay',
  Chest = 'chestPageEnabled',
  CommunityForum = 'CommunityForumLinksInHeaderAndFooter',
  CrossOperatorInactiveStatus = 'CrossOperatorInactiveStatus',
  CustomPIN = 'custom-pin',
  DEAllowed = 'DE_Allowed',
  DELossLimit = 'DE_losslimit',
  DEPanic = 'DE_Panic',
  DERemove1kCap = 'DE_Remove1kCap',
  DESpendLimit = 'DE_SpendLimit',
  DarkModeEnabled = 'dark_mode_enabled',
  DisableBuenosAiresFeatures = 'DisableBuenosAiresFeatures',
  DisableNewUkAgeVerificationFlow = 'DisableNewUkAgeVerificationFlow',
  DisablePendingWithdrawalCancellation = 'swc-disable-pending-withdrawal-cancellation',
  DisableRam = 'DisableRam',
  DivertRAMToPoker = 'DivertRAMToPoker',
  DocumentsRequestPrompt = 'document_request_prompt',
  DynamicCmsBanners = 'DynamicCmsBanners',
  ESActivitySummaryReport = 'ES_ActivitySummaryReport',
  ESportsBookAuth = 'eSportsBookAuth',
  EnableATSExchangeBetsLink = 'EnableATSExchangeBetsLink',
  EnableATSLegacyPreferences = 'EnableATSLegacyPreferences',
  EnableATSMaintenance = 'EnableATSMaintenance',
  EnableBigWinningsGQLSubscription = 'EnableBigWinningsGQLSubscription',
  EnableCommsPreferencesOnRG = 'enableCommsPreferencesOnRG',
  EnableExchange = 'EnableExchange',
  EnableOneTrust = 'enableOneTrust',
  EnablePanicButton = 'enablePanicButton',
  EnableSentry = 'enableSentry',
  EnableTombolaContentCBSE = 'enableTombolaContentCBSE',
  EuDeOasisStreetAddress = 'EUDE_Oasis_Street_Address',
  FeedbackVerification = 'feedback-csat-verification',
  FixedPrizeDrawNotificationEnabled = 'FixedPrizeDrawNotificationEnabled',
  FooterDateTime = 'footer_date_time',
  ForceDefaultLocale = 'ForceDefaultLocale',
  FreeBets = 'freebets',
  FreeSpins = 'eFreeSpinsBonuses',
  Freemium = 'eFreemium',
  FreemiumMobile = 'eFreemiumMobile',
  GreyhoundRacingEnabled = 'ISP_GreyhoundRacingEnabled',
  HandHistoryRAMMyHandHistoryRequests = 'HandHistory_RAM_MyHandHistoryRequests',
  HideRemoveSlfImpLimit = 'hide_RemoveSlfImpLimit',
  HideRsaTokenMenu = 'hideRsaTokenMenu',
  HideStarsPinMenu = 'hideStarsPinMenu',
  HomeGamesNewTab = 'HomeGamesNewTab',
  HorseRacingEnabled = 'ISP_HorseRacingEnabled',
  IDScanHosted = 'IDScan-Hosted',
  IDScanSDK = 'IDScan-SDK',
  ISPAmericanOdds = 'ISP_AmericanOdds',
  ISPAnimalRacingSpecials = 'ISP_Release_AnimalRacingSpecials',
  ISPBetBuilder = 'ISP_BetBuilder',
  ISPBetBuilderNewTag = 'ISP_BetBuilderNewTag',
  ISPBetSlipCustomKeyboard = 'ISP_BetSlipCustomKeyboard',
  ISPBonusCash = 'ISP_BonusCash',
  ISPCashOut = 'ISP_CashOut',
  ISPDataVisualisation = 'ISP_DataVisualisation',
  ISPDisplayEventsWithoutMappedMarkets = 'ISP_DisplayEventsWithoutMappedMarkets',
  ISPDynamicAlternates = 'ISP_DynamicAlternates',
  ISPEnableCorrectScoreTemplate = 'ISP_Enable_CorrectScoreTemplate',
  ISPEnableEventPagePopularBetBuilders = 'ISP_Enable_EventPagePopularBetBuilders',
  ISPEnableHomePagePopularBetBuilders = 'ISP_Enable_HomePagePopularBetBuilders',
  ISPEnableLandingPagePopularBetBuilders = 'ISP_Enable_LandingPagePopularBetBuilders',
  ISPEnablePromotionsQuickLink = 'ISP_Enable_PromotionsQuickLink',
  ISPExperimentPopularBetBuilderCount = 'ISP_Experiment_PopularBetBuilderCount',
  ISPHistoricalBets = 'ISP_HistoricalBets',
  ISPICEPromotions = 'ISP_ICE_Promotions',
  ISPMigrationBanner = 'ISP_Migration_Banner',
  ISPMyStarsFreeBets = 'Visibility_MyStars_FreeBets',
  ISPPromotionPicker = 'ISP_PromotionPicker',
  ISPPromotions = 'ISP_Promotions',
  ISPQuickSwitcher = 'ISP_QuickSwitcher',
  ISPReleaseEventPageWidget = 'ISP_Release_EventPageWidget',
  ISPRouting = 'ISP_Routing',
  ISPScoreboards = 'ISP_Scoreboards',
  ISPSportLandingPage = 'ISP_Release_SportLandingPage',
  ISPSportsFreeBets = 'ISP_FreeBets',
  ISPStatusCheck = 'ISP_StatusCheck',
  ISPUnauthenticatedPromotionsQuickLink = 'ISP_UnauthenticatedPromotionsQuickLink',
  Ice2Feature = 'ice2',
  IceFeature = 'eIceFeatureEnabled',
  IceLeaderboard = 'eIceLeaderBoard',
  IdpSecondaryLoginEnabled = 'idp-secondary-login-enabled',
  InstantBonusesVisibility = 'Visibility_MyStars_InstantBonuses',
  JWTEnabled = 'JWTEnabled',
  LiveChatSupport = 'eLiveChatSupport',
  LoginSEDialogue = 'loginSEDialogue',
  LoginSummaryNotificationModification = 'login-summary-notification-modification',
  LowBalancePrompt = 'wc2-balance-low-prompt',
  LoyaltyWidgetRefresh = 'Loyalty_WidgetRefresh',
  MiniGameTickets = 'eMiniGameTickets',
  MultiCurrency = 'multi-currency',
  NPS = 'SW-SimpleNPS',
  NPSPhase2 = 'SW-NPSPhase2',
  NewContactSupportForm = 'newCsf',
  NoCasinoGameHistory = 'noCasinoGameHistory',
  NoLanguages = 'noLanguages',
  NoPokerStarsRewards = 'noPokerStarsRewards',
  PKRHomeGamesEmptyStateSideWall = '2023.Q1.Poker.HomeGames.RighSideBar.POKER-5484',
  PKRHomeGamesGameTilesUnsupported = '2022.Q2.Poker.HomeGames.GameTiles.WEB-10835',
  PKRHomeGamesJoinAndCreatePublicClubs = '2023.Q4.Poker.HomeGames.JoinAndCreatePublicClubs.POKER-9619',
  PKRHomeGamesLightMode = '2022.Q4.Poker.HomeGames.LightMode.POKER-2246',
  PKRHomeGamesNewSideBar = '2022.Q3.Poker.HomeGames.Sidebar.POKER-258',
  PKRHomeGamesOnboardingCreateGame = '2022.Q2.Poker.HomeGames.OBCreateGame.POKER-348',
  PKRHomeGamesOnboardingFirstTime = '2022.Q3.Poker.HomeGames.OBFirstTimeUX.POKER-378',
  PKRHomeGamesOnboardingJoinClub = '2022.Q2.Poker.HomeGames.OBJoinClub.POKER-371',
  PKRHomeGamesPublicClubSearch = '2023.Q1.Poker.HomeGames.BasicSearch.POKER-252',
  PKRHomeGamesPublicClubs = '2022.Q4.Poker.HomeGames.PublicClubs.POKER-1917',
  PKRHomeGamesQuickCreateTournament = '2022.Q3.Poker.HomeGames.QuickCreateTournament.POKER-1797',
  PKRHomeGamesTheWall = '2022.Q4.Poker.HomeGames.TheWall.POKER-1645',
  PKRHomeGamesVideoChatToggleRedesign = '2022.Q4.Poker.HomeGames.VideoChatToggleRedesign.POKER-2012',
  PKRMultiTableTournamentsResolverServiceV1 = '2024.Q2.Poker.WebMTT.ResolverServiceV1.POKER-11668',
  PKRMultiTableTournamentsVisibility = '2023.Q4.Poker.WebMTT.Visibility.POKER-8355',
  PKRSpinAndGoFlashAvailable = '2023.Q4.Poker.WebSAG.FlashAvailable.POKER-9938',
  PKRSpinAndGoHoldemAvailable = '2023.Q4.Poker.WebSAG.HoldemAvailable.POKER-9938',
  PKRSpinAndGoMaxHoldemAvailable = '2023.Q4.Poker.WebSAG.MaxHoldemAvailable.POKER-8580',
  PKRSpinAndGoOmahaAvailable = '2023.Q4.Poker.WebSAG.OmahaAvailable.POKER-8580',
  PKRSpinAndGoWatchGamesVisibility = '2023.Q4.Poker.WebSAG.WatchGamesVisibility.POKER-7799',
  PRHub = 'PromoExp_PromotionsAndRewards',
  PSMessenger = 'PSMessenger',
  PSMessengerConfig = 'PSMessengerConfig',
  PSMessengerIgnoreLogin = 'PSMessengerIgnoreLogin',
  PSMessengerToggle = 'PSMessengerToggle',
  PlayMoney = 'playMoney',
  PmcPaywall = 'pmc-paywall',
  PredictorGame = 'predictorGameEnabled',
  PublicLiveChatSupport = 'ePublicLiveChatSupport',
  RGLugasDepositLimit = 'RGLugasDepositLimit',
  ReleaseBonuses = 'ReleaseBonuses',
  RemoveUserIdFromIframeUrl = 'remove-userid-from-iframe',
  ResolverRewriteForWC2 = 'resolver-rewrite-for-wc2',
  RestrictSeWeeklyLimit = 'restrict-se-weekly-limit',
  RewardsStore = 'Visibility_MyStars_RewardsStore',
  RmfEmployerInfo = 'rmf-employer-info',
  SFConfig = 'SFConfig',
  SelfExclusionNewDesign = 'SelfExclusionNewDesign',
  SeparatedEulaPrivacyPolicy = 'separated_eula_privacy_policy',
  SessionPopupExtended = 'sessionPopupExtended',
  ShowJackpotWheel = 'Show-Jackpot-Wheel',
  SignUpShowState = 'SignUpShowState',
  SnowplowAnalytics = 'snowplow-analytics',
  SportsBonusCash = 'Visibility_MyStars_BonusCash',
  SportsBookLimits = 'eSportsBookLimits',
  SportsBookNonAuth = 'eSportsBookNonAuth',
  SportsBookOptions = 'eSportsBookOptions',
  SportsNonAuth = 'sports-non-auth',
  SwcAffiliateBonus = 'swc-affiliate-bonus',
  SwcCashier = 'swc-cashier',
  SwcCreditTime = 'swc-credit-time',
  SwcDeposit = 'swc-deposit',
  SwcDepositLimitButtonDisplay = 'swc-depositlimit-button-display',
  SwcDepositMethodMinimum = 'swc-deposit-method-minimum',
  SwcDepositReloader = 'swc-deposit-reloader',
  SwcDispalyAutoConversionCTA = 'swc-display-autoconversion-cta',
  SwcECheckConfirmation = 'swc-eCheck-confirmation',
  SwcEmailVerification = 'swc-email-verification',
  SwcExitFlow = 'swc-exit-flow',
  SwcExploreCta = 'swc-explore-cta',
  SwcManageCurrencies = 'swc-manage-currencies',
  SwcMethodVerification = 'swc-method-verification',
  SwcNewCashierNotification = 'swc-new-cashier-notification',
  SwcOnboardingProgressbar = 'swc-onboarding-progressbar',
  SwcP2pTransfer = 'swc-p2ptransfer',
  SwcPaypalSandboxQA = 'swc-paypal-sandbox-qa',
  SwcRMFPhoneVerification = 'swc-rmf-phone-verification',
  SwcReloaderBonus = 'swc-reloader-bonus',
  SwcRetryScreen = 'swc-retry-screen',
  SwcRmfAddressSearch = 'swc-rmf-address-search',
  SwcRmfFiscalCodeGenerator = 'swc-rmf-fiscalcodegenerator',
  SwcRmfNoLimits = 'swc-rmf-no-limits',
  SwcRmfShowOnlyWeeklyLimit = 'swc-rmf-show-only-weekly-limit',
  SwcSGScreen = 'swc-sg-screen',
  SwcSignup = 'swc-signup',
  SwcSignupDeposit = 'swc-signup-deposit',
  SwcSignupItChallengeQuestions = 'swc-signup-it-challengequestions',
  SwcSignupOnePage = 'swc-signup-onepage',
  SwcSignupPhoneCollection = 'swc-signup-phone-collection',
  SwcSignupRmf = 'swc-signup-rmf',
  SwcSignupRmfAutofocus = 'swc-signup-rmf-autofocus',
  SwcSignupRmfEcoEransitionTwo = 'swc-signup-rmf-ecotransitiontwo',
  SwcSignupRmfEcopokerLobby = 'swc_signup_rmf_ecopokerlobby',
  SwcSignupRmfSumSub = 'swc-signup-rmf-sumsub',
  SwcTransactionHistoryFilters = 'swc-transaction-history-filters',
  SwcTurorial = 'swc-tutorial',
  SwcWelcomeBonusScreen = 'swc-welcomebonus-screen',
  SwcWithdrawal = 'swc-withdrawal',
  SwcWithdrawalCreditTime = 'swc-withdrawal-credit-time',
  SwcWithdrawalMethodMinimum = 'swc-withdrawal-method-minimum',
  SwcXpayLibraryTestStatus = 'swc-xpay-library-test-status',
  TemporaryLoginTimeLimit = 'temporaryLoginTimeLimit',
  TheDeal = 'the-deal',
  TheDealHighRoller = 'the-deal-highroller',
  TwitchConnect = 'TwitchConnect',
  UseRam1 = 'UseRam1',
  VegasPanicButtonDialogNewText = 'de-vegas-panic-button-dialog-new-text',
  VerificationRMOKCheck = 'docverify-check-rmok',
  VerifyAccount = 'verify-account',
  VerifyAccountAfterRmf = 'verify-account-after-rmf',
  VerifyAccountDrivingLicense = 'verify-account-driving-license',
  VerifyAccountNationalId = 'verify-account-national-id',
  VerifyAccountPassport = 'verify-account-passport',
  VerifyDoc = 'verify-doc',
  VerifyWCSF = 'verify-wcsf',
  VisibilityOASISExclusionOption = 'visibility_OASIS_exclusion_option',
  VisibilityPlayingInsights = 'Visibility_Playing_Insights',
  VisibilityPlayingInsightsLoginPopup = 'Visibility_Playing_Insights_Login_popup',
  VisibilityRestrictWithdrawalCancellation = 'visibility_restrict_withdrawal_cancellation',
  Wc2PlayMoney = 'wc2-playmoney',
  WebMPCNotificationEnabled = 'WebMPCNotificationEnabled',
  WebNotificationEnabled = 'WebNotificationEnabled',
  WrmfAcAutotrigger = 'wrmf-ac-autotrigger'
}
